import React from "react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { SelectList } from "@common/selectList";
import { ToggleArrowIcon } from "@common/assets/toggleArrowIcon";
import { GanttSort } from "@planzone/dto";
import { Props } from "./types";
import styles from "./styles.scss";

function Sort({ sort, select }: Props) {
  const { t } = useTranslation();
  const options: GanttSort[] = [
    "ascendingRank",
    "ascendingName",
    "descendingName",
    "ascendingStartDate",
    "ascendingEndDate",
    "ascendingCompletionDate",
  ];

  return (
    <div className={styles.sort}>
      <p className={styles.label}>
        {t("projectPage.listsPage.filters.sorter.title")}
      </p>
      <div className={styles.form}>
        <SelectList listClassName={styles.listRoot}>
          {({ isOpen }) => ({
            input: (
              <div
                className={classNames(styles.input, {
                  [styles.opened]: isOpen,
                })}
              >
                <p className={styles.placeholder}>
                  {t(`projectPage.listsPage.sorts.${sort}`)}
                </p>
                <ToggleArrowIcon className={styles.icon} />
              </div>
            ),
            list: (
              <ul className={styles.list}>
                {options.map((option) => (
                  <li
                    className={classNames(styles.item, {
                      [styles.selected]: sort === option,
                    })}
                    onClick={() =>
                      select(option === sort ? "ascendingRank" : option)
                    }
                  >
                    <p className={styles.option}>
                      {t(`projectPage.listsPage.sorts.${option}`)}
                    </p>
                  </li>
                ))}
              </ul>
            ),
          })}
        </SelectList>
      </div>
    </div>
  );
}

export { Sort };
